<template>
  <div>
    <PageHeader />
    <ProjInfo :projectInfo="projectInfo" noInstall />

        <v-container class="section-block">

            <v-row>
                <v-col class="col-12 col-md-8">
                    <v-responsive :aspect-ratio="16/9">
                        <video width="100%" src="/video/Dotkit-Timeline.mp4" autoplay loop muted></video>
                    </v-responsive>
                </v-col>
            </v-row>

            <v-row>
                <v-col class="col-12 col-sm-6 col-md-4">
                    <video width="100%" src="/video/Dotkit-Custom.mp4" autoplay loop muted></video>
                    <h2>Basics</h2>
                    <p>
                        The system uses a set of 4 dynamic dots which inherit position data from states in the timeline. As new states are added to the timeline, the dots will automatically transition to the next state.
                    </p>
                    <p>
                        States can (and should) be reused. Drop a state into the timeline and turn off its eyeball. The dynamic dots will reach into the state comp and pull out the appropriate data. No additional keyframes required.
                    </p>
                </v-col>
                <v-col class="col-12 col-sm-6 col-md-4">
                    <img src="/images/Dotkit_Parameters.png" width="100%" alt="">
                    <h2>Parameters</h2>
                    <h4>Transition Speed</h4>
                    <p>
                        Transitioning between states is controlled by this set of keyframes.
                    </p>
                    <h4>Dot Size</h4>
                    <p>
                        Can be manually set, but for most states 66 is the recomended size.
                    </p>
                    <h4>Inherit Scale</h4>
                    <p>
                        Several states use complex parenting to create smooth movement. Some states use dot scaling to achieve the desired effect. Enable or disable depending on the state you transition into.
                    <h4>Trail Length</h4>
                    <p>
                        When dots get moving super fast they can benefit from some trails to lead the eye and now it may be draw dynamically.
                    </p>
                </v-col>
                <v-col class="col-12 col-sm-6 col-md-4">
                    <video width="100%" src="/video/Dotkit-1and1.mp4" autoplay loop muted></video>
                    <h2>Custom States</h2>
                    <p>
                        Not every states can be rendered with the dynamic dots. States like Mic and TTS require that the dots change shape. These are called custom states and are left visible (eyeball on). Leaving a state visible will override the dynamic dots so you dont end up with too many dots floating around.
                    </p>
                </v-col>
            </v-row>
        </v-container>

        
        <v-container class="section-block">
        <v-row>
            <v-col class="col-12 col-sm-6 col-md-4">
                <div class=" group-header">Included states</div>
            </v-col>
        </v-row>
            
        <div v-for="(type, typeIndex) in dotStates" :key="typeIndex" class="state-box">
            <h2>{{ typeIndex | uppercase }}</h2>
            <v-row>
                <v-col v-for="(state, stateIndex) in type" :key="stateIndex" class="col-6 col-sm-4 col-md-3" no-gutters>
                    <img :src="`/gif/dotkit/${state}.gif`" style="width: inherit" :alt="state">
                    <h4>{{ state }}</h4>
                </v-col>
            </v-row>
        </div>
    </v-container>

    
    <!-- <InstallInfo :projectInfo="projectInfo" /> -->
  </div>
</template>

<script>

export default {
    name: 'dotkit',
    components: {
    },
    data: () => ({
        projectInfo: {
            name: 'DotKit 1',
            subtitle: 'Animating the dots with states, not keyframes',
            download: '/download/DotKit_1.2.zip',
            version: '1.2',
            updated: 'Aug 24, 2018',
            about: `The dots are playful and fun but no one likes to hand keyframe 4 sets of circles. Take control of the dots by editing states together like a video timeline. Dotkit will interpolate between states to make flows a breeze.
            Dotkit is an Ae project file that may be imported as needed.`
        },
        dotStates: {
            assistant: [
                '00_Listening',
                '01_Listening to Molecule',
                '02_Molecule to Listening',
                '03_Molecule Mic Closed',
                '04_Molecule Thinking',
                '05_Molecule TTS',
                '06_Custom - User Input',
                '07_G-to-Molecule',
            ],
            gsa: [
                'Dots to mic',
                'Didnt get it',
                'Got it',
                'Loading',
                'Readback',
                'Thinking',
            ],
            extras: [
                'Dots to G',
                'G to dots',
                'Dots to logo',
                'Logo to dots',
            ],
        }
    }),
    filters: {
        uppercase(str) {
            return str.toUpperCase()
        }
    }
}
</script>

<style scoped>
/* .state-box {
    background: #fff;
    margin: 16px 12px;
    padding: 16px 0;
}
.state-box h3 {
    padding-left: 16px;
} */
.state-box img {
    border: 1px solid rgba(0,0,0,0.03);
}
.state-box .col {
    margin-bottom: 18px;
}

</style>